interface GrowthHouseLogoProps {
  size?: number
}

export default function GrowthHouseLogo({ size = 56 }: GrowthHouseLogoProps) {
  return (
    <svg viewBox="0 0 32 32" fill="none" width={size} height={size} data-testid="growth-house-logo">
      <rect x="1" y="1" width="13" height="13" rx="2" fill="#5B8FA8" />
      <rect x="18" y="1" width="13" height="13" rx="2" fill="#A8C8D8" />
      <rect x="1" y="18" width="13" height="13" rx="2" fill="#E8983E" />
    </svg>
  )
}
